module.exports = __webpack_public_path__ + "jira-logo.png";